const initialState = {
  listSupervisor: [],
  closeTabTargetSupervisor: false,
  statusInputTargetSpv: true,
  statusInputTargetSpvProduktif: true,
  listTargetSupervisor: [],
  listTargetSupervisorProduktif: [],
};

const supervisorReducer = (state = initialState, action) => {
  let { type, data } = action;
  switch (type) {
    case "SET_CLOSE_TAB_TARGET_SUPERVISOR":
      return {
        ...state,
        closeTabTargetSupervisor: data,
      };
    case "SET_ALLSUPERVISOR":
      return {
        ...state,
        listSupervisor: data,
      };
    case "SET_STATUS_INPUT_TARGET_SUPERVISOR":
      return {
        ...state,
        statusInputTargetSpv: data,
      };
    case "SET_ALL_TARGET_SUPERVISOR":
      return {
        ...state,
        listTargetSupervisor: data,
      };
    case "SET_ALL_TARGET_SUPERVISOR_PRODUKTIF":
      return {
        ...state,
        listTargetSupervisorProduktif: data,
      };
    case "SET_STATUS_INPUT_TARGET_SUPERVISOR_PRODUKTIF":
      return {
        ...state,
        statusInputTargetSpvProduktif: data,
      };
    default:
      return state;
  }
};
export default supervisorReducer;
